import { AppBar, Stack, darken, getContrastRatio } from '@mui/material';

import { HeaderMenu } from './components/headerMenu';

type HeaderProps = {
  isSidebarCollapsed: boolean;
};

export const Header = (props: HeaderProps) => {
  const { isSidebarCollapsed } = props;
  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          zIndex: theme => theme.zIndex.drawer + 1,
          bgcolor: 'background.paper',
          boxShadow: 'none',
        }}
      >
        <Stack
          px={2}
          direction="row"
          alignItems="center"
          position="relative"
          height="100%"
          color={t =>
            getContrastRatio(
              t.palette.primary.main,
              t.palette.background.paper,
            ) > 1
              ? darken(t.palette.primary.main, 0.6)
              : t.palette.common.white
          }
        >
          <HeaderMenu isSidebarCollapsed={isSidebarCollapsed} />
        </Stack>
      </AppBar>
    </>
  );
};
